(ns app.front.view.party.party-section-v2
  (:require [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.party :as party]
            [app.front.view.party.assign-role :as assign-role]
            [app.front.view.party.business :as party-business]
            [app.front.view.party.common :as party-common]
            [app.front.view.party.invite-v2 :as invite]
            [app.front.view.party.requirements :as party-requirements]
            [app.front.view.party.subs :as party-subs]
            [app.front.view.party.subs-req :as party-req-subs]
            [app.front.view.workspace.section :as ws-section]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::parties-section-open?
  (fn [db [_ parent-id]]
    (contains? (get db ::phase-ids-with-parties-section-open #{}) parent-id)))

(rf/reg-event-fx ::trigger-add-required-party-role
  (fn [{:keys [db]} [_ process-target]]
    {:db (update db ::phase-ids-with-parties-section-open (fnil conj #{}) (:db/id process-target))
     :fx [[::futil/scroll-to-section :application-parties]
          [:dispatch [::party-requirements/open-add-required-role-dropdown (:db/id process-target)]]]}))

(rf/reg-event-fx ::trigger-add-party
  (fn [_ [_ process-target]]
    (let [authority? (-> process-target :granted-permissions :permission.phase/authority-read)]
      {:fx (cond-> [[:dispatch [::party-common/init :invite]]
                    [:dispatch [::party-business/init]]]
             (not authority?)
             (conj [:dispatch [::party-business/fetch-my-businesses]]))})))

(defn party-trigger [{:keys [tr parent]}]
  (when (<sub [::process/signal-permitted? (:db/id parent) [:process.signal/add-party]])
    [:div.mt-4
     [ui/button
      {:kind             :tertiary
       :on-click         #(>evt [::trigger-add-party parent])
       :icon             i/plus
       :icon-description (tr [:application/invite-button])}
      (tr [:application/invite-button])]]))

(defn parties [{:keys [tr parent]}]
  (let [lang                             (<sub [:language])
        parent-id                        (:db/id parent)
        parties                          (<sub [::party-subs/parties parent-id])
        parties-w-missing-trade+role-ids (<sub [::party-subs/parties-with-missing-required-trade+role-ids parent-id])
        parties-wo-missing-trade         (<sub [::party-subs/parties-without-missing-trade parent-id])
        party-role-requirements          (<sub [::party-req-subs/party-role-requirements parent-id])
        authority?                       (-> parent :granted-permissions :permission.phase/authority-read)
        has-parties?                     (seq parties)
        has-required-party-roles?        (seq party-role-requirements)
        can-add?                         (<sub [::process/signal-permitted? parent-id [:process.signal/add-party]])
        section-open?                    (<sub [::parties-section-open? parent-id])
        ui-improvements?                 (<sub [::ff/enabled? :feature-flag.id/inspection-ui-improvements])
        show-section?                    (if ui-improvements?
                                           (or has-parties? has-required-party-roles? section-open?)
                                           (or has-parties? can-add?))]
    [:<>
     (when show-section?
       [ws-section/section
        parent-id
        :application-parties
        (util/mmap {:heading-tag (count parties)}
                   tr)
        :application/parties-of-the-application
        true
        (let [ctx (util/mmap lang tr)]
          [:div
           [party-requirements/requirements (util/mmap tr parties lang parent parties-w-missing-trade+role-ids)]
           [:div.border-t.border-solid.border-ui-gray.pt-6
            [:div.bold.mb-4 (tr [:party/additional-parties])]
            [:div (tr [:party/additional-parties-info])]
            [party-trigger (util/mmap tr parent authority?)]
            (into
              [:div.bx--row.mt-2 {:key :parties-container}]
              (for [party parties-wo-missing-trade]
                [:div.responsive-column-full
                 {:key (str (:db/id party) "-party")}
                 [party/party-view ctx party parent]]))]
           (when (not-empty parties-w-missing-trade+role-ids)
             [:div.mt-6
              [:p.-mb-6.lg:w-2-3 (tr [:party/party-trades-missing-info])]
              (into
                [:div.bx--row.mt-2 {:key :parties-container}]
                (for [[party role-ids] parties-w-missing-trade+role-ids]
                  [:div.responsive-column-full
                   {:key (str (:db/id party) "-party")}
                   [party/party-view ctx party parent role-ids]]))])])])
     [:div
      {:key "add-person"}
      [invite/invite-modal tr parent parties]
      [assign-role/assign-modal tr parent parties]]]))
